// extracted by mini-css-extract-plugin
module.exports = {"root":"P_b4","error":"P_r"};